const signerCompletionFromSummary = (document, signer) => {
  const signerId = signer?.id || document?.current_signer?.id
  const signers = document?.assignment?.summary?.signers

  if (!signerId || !Array.isArray(signers)) return undefined

  const completed = signers.find((candidate) => candidate.id === signerId)?.completed
  return typeof completed === "boolean" ? completed : undefined
}

const currentSignerCompletion = (document, signer) => {
  if (typeof document?.current_signer?.completed === "boolean") {
    return document.current_signer.completed
  }

  return signerCompletionFromSummary(document, signer)
}

const documentUnavailableStatus = () => ({
  key: "document_unavailable",
  variant: "warning",
  icon: "icon-warning",
  title: "Documento indisponível",
  message:
    "Este documento não está mais disponível para assinatura. Se precisar de ajuda, entre em contato com o remetente.",
})

export const resolveSigningLinkStatus = (document, signer) => {
  if (document?.status === "certificated") {
    return {
      key: "document_completed",
      variant: "success",
      icon: "icon-check",
      title: "Documento concluído",
      message:
        "Sua assinatura foi realizada e todas as etapas deste documento foram concluídas. Consulte seu e-mail para acessar a cópia assinada.",
    }
  }

  if (
    typeof document?.status === "string" &&
    document.status !== "pending_signature" &&
    document.status !== "certificating"
  ) {
    return documentUnavailableStatus()
  }

  if (document?.is_closed) {
    return {
      key: "document_closed",
      variant: "warning",
      icon: "icon-warning",
      title: "Documento encerrado",
      message: "Este documento foi encerrado e não está mais disponível para assinatura.",
    }
  }

  if (currentSignerCompletion(document, signer) === true) {
    if (document?.status === "certificating") {
      return {
        key: "document_processing",
        variant: "success",
        icon: "icon-check",
        title: "Sua assinatura já foi concluída",
        message:
          "O documento está sendo finalizado. Você receberá uma cópia por e-mail assim que estiver pronto.",
      }
    }

    if (document?.status === "pending_signature") {
      return {
        key: "signature_completed",
        variant: "success",
        icon: "icon-check",
        title: "Sua assinatura já foi concluída",
        message:
          "Você não precisa assinar novamente. O documento ainda aguarda as outras assinaturas e, quando todos concluírem, você receberá uma cópia por e-mail.",
      }
    }
  }

  if (document?.status === "pending_signature") return null

  return documentUnavailableStatus()
}

const resolveKnownSigningLinkStatus = (document, signer) => {
  if (document?.status === "certificated" || document?.is_closed) {
    return resolveSigningLinkStatus(document, signer)
  }

  const signerCompletion = currentSignerCompletion(document, signer)

  if (document?.status === "pending_signature" && typeof signerCompletion === "boolean") {
    return resolveSigningLinkStatus(document, signer)
  }

  if (typeof document?.status === "string" && document.status !== "pending_signature") {
    return resolveSigningLinkStatus(document, signer)
  }

  return undefined
}

export const resolvePostVerificationStatus = async ({ document, signer, loadDocument }) => {
  const knownStatus = resolveKnownSigningLinkStatus(document, signer)

  if (typeof knownStatus !== "undefined") {
    return { document, status: knownStatus }
  }

  try {
    const fullDocument = await loadDocument()
    const fullDocumentStatus = resolveKnownSigningLinkStatus(fullDocument, signer)

    return {
      document: fullDocument,
      status: typeof fullDocumentStatus === "undefined" ? null : fullDocumentStatus,
    }
  } catch {
    return { document, status: null }
  }
}
